module.exports = __webpack_public_path__ + "static/media/bespoke-events.ae10e321.webp";